module.exports = __webpack_public_path__ + "static/img/product-onay-bekleyen-warning.92cd1f7d.svg";